import pageHeader from '@/components/app/header/page-header/page-header.vue'

export default {
  components: {
    pageHeader
  },
  data() {
    return {
      isButtonInHeader: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/main-pages/main-pages.js